import { Box } from '@mui/material'
import { t } from 'i18next'
import { useAppSelector } from '../../store/redux/hooks'
import { getCurrentUser } from '../../store/redux/reducers/currentUserSlice'
import { Download, FileCopy } from '@mui/icons-material'
import MasonryTileTitle from '../../components/Masonry/MasonryTileTitle'
import { StyledScheduleStickyTitle } from '../../styles/ScheduleViewStyles'
import MasonryTile from '../../components/Masonry/MasonryTile'
import GroupImportDialog from '../../components/Dialog/GroupImportDialog'
import SettingTile from './SettingTile'
import YearPicker from '../../components/YearPicker/YearPicker'

type MasonryTileImportExportProps = {
  handleDownloadWorklogZipReport: () => Promise<void>
  isLoading: boolean
}

const MasonryTileImportExport = ({ handleDownloadWorklogZipReport, isLoading }: MasonryTileImportExportProps) => {
  useAppSelector(state => getCurrentUser(state))

  return (
    <MasonryTile>
      <StyledScheduleStickyTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <MasonryTileTitle title={t('page.adminsPage.generalSettings.exportImport')} icon={FileCopy} sx={{ gap: 2 }} />
          <YearPicker />
        </Box>
      </StyledScheduleStickyTitle>

      <SettingTile
        icon={<Download />}
        title={t('page.adminsPage.generalSettings.generate.title')}
        description={t('page.adminsPage.generalSettings.generate.description')}
        onSelect={handleDownloadWorklogZipReport}
        isLoading={isLoading}
      />

      <GroupImportDialog disabled={false} fullWidth={false} squareButton={false} />
    </MasonryTile>
  )
}

export default MasonryTileImportExport
